import { createContext, useState } from 'react';

import { createStore } from 'jotai';

import type { RouterProviderContext, RouterProviderProps } from './router.types';

const Context = createContext<RouterProviderContext | undefined>(undefined);

const Provider = ({ children, router }: RouterProviderProps) => {
  const [store] = useState(() => createStore());
  return <Context.Provider value={{ store, ...router }}>{children}</Context.Provider>;
};

export { Context as RouterContext, Provider as RouterProvider };
